'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_Badge_Badge = require('../../display/Badge/Badge.cjs.js');
const components_display_FloatingBox_FloatingBox = require('../../display/FloatingBox/FloatingBox.cjs.js');
const components_display_Tag_Tag = require('../../display/Tag/Tag.cjs.js');
const components_navigation_LegacyIconButton_IconButton = require('../LegacyIconButton/IconButton.cjs.js');
const components_forms_Menu_Menu = require('../../forms/Menu/Menu.cjs.js');
const components_forms_Menu_MenuItem = require('../../forms/Menu/MenuItem.cjs.js');
const hooks_useClickOutside = require('../../../hooks/useClickOutside.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const tabsDropdown = "_tabs-dropdown_ylq6o_1";
const summary = "_summary_ylq6o_5";
const menu = "_menu_ylq6o_12";
const badgeAndTag = "_badge-and-tag_ylq6o_17";
const styles = {
	tabsDropdown: tabsDropdown,
	summary: summary,
	menu: menu,
	badgeAndTag: badgeAndTag
};

const TabsDropdown = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const menuItems = props.items.map((item) => React__default.default.createElement(
    components_forms_Menu_MenuItem.MenuItem,
    { disabled: item.disabled, href: item.href, isSelected: item.href === props.selectedItemHref, key: item.href, onClick: (event) => {
      setIsOpen(false);
      props.onChooseItem(item, event);
    } },
    item.text,
    item.badgeText && React__default.default.createElement(components_display_Badge_Badge.Badge, { variant: item.badgeVariant, className: styles.badgeAndTag }, item.badgeText),
    item.tagText && React__default.default.createElement(components_display_Tag_Tag.Tag, { variant: item.tagVariant, className: styles.badgeAndTag }, item.tagText)
  ));
  const [setClickOutsideNode] = hooks_useClickOutside.useClickOutside({
    onClickOutside: () => {
      setIsOpen(false);
    }
  });
  const containerHandlers = {
    onKeyUp: (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    }
  };
  return React__default.default.createElement(
    "div",
    Object.assign({ ref: setClickOutsideNode }, containerHandlers, { "data-zds": true }),
    React__default.default.createElement(components_navigation_LegacyIconButton_IconButton.LegacyIconButton, { color: "icon-tertiary", icon: "navMoreHoriz", label: "More items…", "aria-expanded": isOpen, onClick: () => setIsOpen(!isOpen), size: "small", tooltipPosition: "west" }),
    isOpen && React__default.default.createElement(
      components_display_FloatingBox_FloatingBox.FloatingBox,
      { align: "right" },
      React__default.default.createElement(
        "div",
        { className: styles.menu, "data-zds": true },
        React__default.default.createElement(components_forms_Menu_Menu.Menu, { "aria-label": "" }, menuItems)
      )
    )
  );
};

exports.TabsDropdown = TabsDropdown;
//# sourceMappingURL=TabsDropdown.cjs.js.map
